import { useMemo } from 'react';
import { GridContext } from '../Context';
import { GridContainer } from '../styled';
export function Grid(props) {
    const { children, spacing = 6, directions = 'horizontal vertical', className } = props;
    const [horizontal, vertical] = useMemo(() => {
        const parts = directions.split(' ');
        return [parts.includes('horizontal'), parts.includes('vertical')];
    }, [directions]);
    return (<GridContainer $spacing={spacing} $horizontal={horizontal} $vertical={vertical} className={className}>
      <GridContext.Provider value={{ spacing, horizontal, vertical }}>{children}</GridContext.Provider>
    </GridContainer>);
}
